import type React from "react";
import { Link } from "react-router-dom";
import {
	NavigationMenu,
	NavigationMenuContent,
	NavigationMenuItem,
	NavigationMenuLink,
	NavigationMenuList,
	NavigationMenuTrigger,
	navigationMenuTriggerStyle,
} from "../../../components/ui/navigation-menu";

const Navigation: React.FC = () => {
	return (
		<NavigationMenu>
			<NavigationMenuList>
				<NavigationMenuItem>
					<Link to="/about" className={navigationMenuTriggerStyle()}>
						学習ギルドについて
					</Link>
				</NavigationMenuItem>
				<NavigationMenuItem>
					<NavigationMenuTrigger>イベント</NavigationMenuTrigger>
					<NavigationMenuContent>
						<ul className="grid gap-3 p-4 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr]">
							<li className="row-span-3">
								<NavigationMenuLink asChild>
									<Link
										className="flex h-full w-full select-none flex-col justify-end rounded-md bg-gradient-to-b from-muted/50 to-muted p-6 no-underline outline-none focus:shadow-md"
										to="/mokumoku"
									>
										<div className="mb-2 mt-4 text-lg font-medium">
											もくもく会
										</div>
										<p className="text-sm leading-tight text-muted-foreground">
											各自が自分の学習テーマに取り組む会
										</p>
									</Link>
								</NavigationMenuLink>
							</li>
							<li>
								<NavigationMenuLink asChild>
									<Link
										className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
										to="/study-groups"
									>
										勉強会
									</Link>
								</NavigationMenuLink>
							</li>
							<li>
								<NavigationMenuLink asChild>
									<Link
										className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
										to="/hackathons"
									>
										ハッカソン
									</Link>
								</NavigationMenuLink>
							</li>
						</ul>
					</NavigationMenuContent>
				</NavigationMenuItem>

				<NavigationMenuItem>
					<Link to="/event-report" className={navigationMenuTriggerStyle()}>
						活動報告
					</Link>
				</NavigationMenuItem>
				<NavigationMenuItem>
					<Link to="/faq" className={navigationMenuTriggerStyle()}>
						よくあるご質問
					</Link>
				</NavigationMenuItem>
				<NavigationMenuItem>
					<Link to="/contact" className={navigationMenuTriggerStyle()}>
						お問い合わせ
					</Link>
				</NavigationMenuItem>
			</NavigationMenuList>
		</NavigationMenu>
	);
};

export default Navigation;
